import React, { Component } from "react"
import { translate } from "react-translate"
import { connect } from "react-redux"

import MenuComponent from "../MenuComponent"
import CarouselComponent from "./CarouselComponent"
import FooterComponent from "../FooterComponent"
import { Link } from "react-router-dom"

import {
  Segment,
  Icon,
  Image,
  Container,
  Header,
  Button,
  Input,
  Responsive,
  Grid,
  Form,
  Divider,
  TextArea,
  Modal
} from "semantic-ui-react"

import { Element } from "react-scroll"

import "./landing.css"
import "./landing_responsive.css"
import imageLanding from "../../../assets/img/image_landing.png"
import image_complet from "../../../assets/icons/Simplicite_icon.png"
import image_temps from "../../../assets/icons/Gain_de_Temps_icon.png"
import image_argent from "../../../assets/icons/Gain_argent_icon.png"
import image_gratuit from "../../../assets/icons/GRATUIT_icon.png"
import image_mail from "../../../assets/img/image_mail.png"
import image from "../../../assets/img/worker.png"
import user from "../../../assets/img/user.png"
import AvisCarouselComponent from "./AvisCarouselComponent"

import image2 from "../../../assets/img/image2.png"
import LandingCarouselComponent from "./LandingCarouselComponent"

import pictureAvis from "../../../assets/img/avis.png"

import video from "../../../assets/img/video.png"
import desktopIcon from "../../../assets/icons/desktop_icon.png"
import mobileIcon from "../../../assets/icons/mobile_icon.png"

import API from "../../../services/api"

const mapStateToProps = state => ({
  app: state.app
})
class LandingComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "contact@mytravo.net",
      mailContactUs: "",
      nameContactUs: "",
      textContactUs: "",
      mailNewsLetter: "",
      isOpen: false
    }

    this.submitContact = this.submitContact.bind(this)
    this.submitNews = this.submitNews.bind(this)
    this.onChangeMailContactUs = this.onChangeMailContactUs.bind(this)
    this.onChangeNameContactUs = this.onChangeNameContactUs.bind(this)
    this.onChangeTextContactUs = this.onChangeTextContactUs.bind(this)
    this.onChangeMailNews = this.onChangeMailNews.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal() {
    this.setState({ isOpen: true })
  }

  closeModal() {
    this.setState({ isOpen: false })
  }

  submitContact(e) {
    e.preventDefault()

    if (
      this.state.mailContactUs === "" ||
      this.state.nameContactUs === "" ||
      this.state.textContactUs === ""
    ) {
    } else {
      var form = new FormData()
      form.append("subject", "contactus")
      form.append("name", this.state.nameContactUs)
      form.append("email", this.state.mailContactUs)
      form.append("message", this.state.textContactUs)
      API.sendMail(this.props.token, form).then(res => {})
    }
  }

  submitNews(e) {
    e.preventDefault()

    if (this.state.mailNewsLetter === "") {
    } else {
      var form = new FormData()
      form.append("subject", "newsletter")
      form.append("email", this.state.mailNewsLetter)
      API.sendMail(this.props.token, form).then(res => {})
    }
  }

  onChangeMailContactUs(e, data) {
    e.preventDefault()
    this.setState({
      mailContactUs: data.value
    })
  }
  onChangeNameContactUs(e, data) {
    e.preventDefault()
    this.setState({
      nameContactUs: data.value
    })
  }
  onChangeTextContactUs(e, data) {
    e.preventDefault()
    this.setState({
      textContactUs: data.value
    })
  }

  onChangeMailNews(e, data) {
    e.preventDefault()
    this.setState({
      mailNewsLetter: data.value
    })
  }

  render() {
    const { t } = this.props
    var sectionStyle = {
      border: "none",
      backgroundColor: "white"
    }
    var buttonStyle = {
      background: "white",
      color: "rgb(9,100,193)"
    }

    return (
      <div>
        <MenuComponent />

        <Grid verticalAlign={"middle"} id="firstCarouselNewLanding">
          <Grid.Row
            textAlign={"left"}
            verticalAlign={"middle"}
            style={{ paddingBottom: "0px" }}
          >
            <LandingCarouselComponent />
            <div id="firstCarouselNewContent">
              <Grid.Column id="firstCarouselNewColumn">
                <Container textAlign={"left"}>
                  <Header as="h1" id="firstCarouselNewContentTitre">
                    {t("Segment1_title")}
                    <span id="firstCarouselNewContentTitreWork">
                      {t("Segment1_travaux")}
                    </span>
                  </Header>
                  <Header as="p" id="firstCarouselNewContentDescription">
                    {t("Segment1_text1")}
                  </Header>
                  <Button
                    inverted
                    circular
                    id="firstCarouselContentButton"
                    style={{ backgroundColor: "rgba(255, 255, 255, 0.141)" }}
                  >
                    <Image src={desktopIcon} />
                    <a id="Segment1_button1_text" href="/works" target="_blank">
                      {t("Segment1_button1_text")}
                    </a>
                  </Button>
                  <Button
                    inverted
                    circular
                    id="firstCarouselContentButton"
                    style={{ backgroundColor: "rgba(255, 255, 255, 0.141)" }}
                  >
                    <Image src={mobileIcon} />
                    <a
                      id="Segment1_button1_text"
                      href="https://play.google.com/store/apps/details?id=com.guidiyam.mytravo"
                      target="_blank"
                    >
                      {t("Segment1_button2_text")}
                    </a>
                  </Button>
                  <Segment
                    vertical
                    compact
                    textAlign="center"
                    id="firstCarouselWrapperVideoText"
                  >
                    <a
                      id="firstCarouselContentVideoText"
                      href={"#"}
                      onClick={this.openModal}
                    >
                      <Image src={video} style={{ display: "inline-block" }} />{" "}
                      — {t("Segment1_video")}
                    </a>
                    <Modal
                      basic
                      size={"large"}
                      open={this.state.isOpen}
                      onClose={this.closeModal}
                    >
                      <iframe
                        width="100%"
                        height="600"
                        src={
                          this.props.app.lang === "fr_FR"
                            ? "https://www.youtube.com/embed/lQgnG3Mfopg"
                            : "https://www.youtube.com/embed/k3CDmkbllPg"
                        }
                      />
                    </Modal>
                  </Segment>
                </Container>
              </Grid.Column>
            </div>
          </Grid.Row>
        </Grid>
        <Grid verticalAlign={"middle"} id="SecondContentNew">
          <Grid.Row textAlign={"center"} verticalAlign={"middle"}>
            <Grid.Column>
              <Container>
                <Header as="h2" id="SecondContentNewTitre">
                  {t("Segment2_title")}
                </Header>
                <Header as="p" id="SecondContentNewDescription">
                  {t("Segment2_description")}
                </Header>
              </Container>
              <Container textAlign={"center"}>
                <CarouselComponent />
              </Container>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid
          stackable
          verticalAlign={"middle"}
          id="thirdContentNew"
          className="element"
        >
          <Grid.Row textAlign={"center"} verticalAlign={"middle"}>
            <Grid.Column>
              <Header as="h1" id="thirdContentNewTitleUs">
                {t("Segment3_title")}
              </Header>
              <Header as="h1" id="thirdContentNewTitle">
                {t("Segment3_description1")}
              </Header>
              {/*<Header as='h2' id="thirdContentNewDescription" >{t("Segment3_description2")}</Header>*/}
              <Container>
                <Grid stackable textAlign={"center"} columns={4} padded>
                  <Grid.Column textAlign={"center"}>
                    <Image src={image_complet} centered />
                    <Container>
                      <Header as="h1" id="thirdContentNewImageTitle">
                        {t("Segment3_complet_title")}
                      </Header>
                      <Header as="p" id="thirdContentNewImageDescription">
                        {t("Segment3_complet_description")}
                      </Header>
                    </Container>
                  </Grid.Column>
                  <Grid.Column textAlign={"center"}>
                    <Image src={image_temps} centered />
                    <Container>
                      <Header as="h1" id="thirdContentNewImageTitle">
                        {t("Segment3_temps_title")}
                      </Header>
                      <Header as="p" id="thirdContentNewImageDescription">
                        {t("Segment3_temps_description")}
                      </Header>
                    </Container>
                  </Grid.Column>
                  <Grid.Column textAlign={"center"}>
                    <Image src={image_argent} centered />
                    <Container>
                      <Header as="h1" id="thirdContentNewImageTitle">
                        {t("Segment3_argent_title")}
                      </Header>
                      <Header as="p" id="thirdContentNewImageDescription">
                        {t("Segment3_argent_description")}
                      </Header>
                    </Container>
                  </Grid.Column>
                  <Grid.Column textAlign={"center"}>
                    <Image src={image_gratuit} centered />
                    <Container>
                      <Header as="h1" id="thirdContentNewImageTitle">
                        {t("Segment3_gratuit_title")}
                      </Header>
                      <Header as="p" id="thirdContentNewImageDescription">
                        {t("Segment3_gratuit_description")}
                      </Header>
                    </Container>
                  </Grid.Column>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid stackable verticalAlign={"middle"} id="FourthContentNew">
          <Grid.Row
            textAlign={"center"}
            verticalAlign={"middle"}
            columns={2}
            id="FourthContentNewRow"
          >
            <Grid.Column
              id="FourthContentNewColumn1"
              mobile={16}
              tablet={8}
              computer={8}
            >
              <Container textAlign={"left"} id="FourthContentTitre">
                <Header color="blue" as="h1" id="FourthContentTitre1">
                  {t("Segment4_title")}
                </Header>
                <Header color="blue" as="h2" id="FourthContentTitre2">
                  {t("Segment4_title2")}
                </Header>
              </Container>

              <Container textAlign={"left"} id="FourthContentDescription">
                <Header as="a" id="FourthContentText1">
                  {t("Segment4_text1")}
                </Header>
              </Container>
            </Grid.Column>
            <Grid.Column
              textAlign={"right"}
              id="FourthContentNewColumn2"
              mobile={16}
              tablet={8}
              computer={8}
            >
              <Image centered src={image} id="FourthContentNewImage" />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid verticalAlign={"middle"} id="FifthContentNew">
          <Grid.Row textAlign={"center"} verticalAlign={"middle"}>
            <Grid.Column>
              <Header as="h1" id="FifthContentNewTitre1">
                {t("Segment5_title")}
              </Header>
              <Header as="h2" id="FifthContentNewTitre2">
                {t("Segment5_description")}
              </Header>
              <AvisCarouselComponent />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid verticalAlign={"middle"} id="sixContent">
          <Grid.Row textAlign={"center"} verticalAlign={"middle"}>
            <Grid.Column>
              <Header as="h1" id="sixContentTitle">
                {t("Segment6_title")}
              </Header>
              <Header as="p" id="sixContentDescription">
                {t("Segment6_description")}
              </Header>
              <Form onSubmit={this.submitNews}>
                <div color="blue" className="ui action right labeled input">
                  <Form.Input
                    placeholder={t("Segment6_button_placeholder")}
                    id="sixContentButton"
                    type="text"
                    onChange={this.onChangeMailNews}
                  />
                  <button
                    type="submit"
                    className="ui button"
                    role="button"
                    id="sixContentButtonRight"
                  >
                    <a id="sixContentButtonRightText">
                      {t("Segment6_button_label")}
                    </a>
                  </button>
                </div>
                <p>
                  <input type="checkbox" required name="terms" />{" "}
                  {t("newsletter_agreement")}{" "}
                  <Link to="/termsandconditions">
                    {t("termsandconditions")}
                  </Link>
                  .{" "}
                </p>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Segment vertical id="seventhContent">
          <Segment vertical textAlign="center" id="seventhContentInside">
            <Header size="medium" as="h2" id="seventhContentTitleTitle">
              {t("Segment7_title")}
            </Header>
            <Header
              as="p"
              textAlign="center"
              id="seventhContentTitleDescription"
            >
              {t("Segment7_description")}
            </Header>
          </Segment>

          <Segment vertical id="seventhContentInside">
            <Grid stackable columns={2} centered padded>
              <Grid.Row>
                <Grid.Column
                  textAlign="right"
                  id="seventhLeftColumn"
                  mobile={16}
                  tablet={8}
                  computer={5}
                >
                  <Grid centered columns={2}>
                    <Grid.Column width={2}>
                      <Icon inverted name="map pin" />
                    </Grid.Column>
                    <Grid.Column width={12} id="dashedBorder">
                      <Header as="a" id="seventhContentLeftAddresse">
                        {t("Segment7_address")}
                      </Header>
                    </Grid.Column>
                  </Grid>
                  <Grid centered columns={2} style={{ paddingTop: "30px" }}>
                    <Grid.Column width={2}>
                      <Icon inverted name="phone" />
                    </Grid.Column>
                    <Grid.Column width={12} id="dashedBorder">
                      <Header as="p" id="seventhContentLeftPhone">
                        {t("Segment7_phone1")}
                      </Header>
                      <Header as="p" id="seventhContentLeftPhone">
                        {t("Segment7_phone2")}
                      </Header>
                    </Grid.Column>
                  </Grid>
                  <Grid centered columns={2} style={{ paddingTop: "30px" }}>
                    <Grid.Column width={2}>
                      <Icon inverted name="mail" />
                    </Grid.Column>
                    <Grid.Column width={12}>
                      <Header as="a" id="seventhContentLeftMail">
                        {t("Segment7_mail")}
                      </Header>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>

                <Grid.Column
                  textAlign="left"
                  id="seventhForm"
                  mobile={16}
                  tablet={8}
                  computer={5}
                >
                  <Form onSubmit={this.submitContact}>
                    <Grid.Row>
                      <Form.Input
                        placeholder="Votre Nom"
                        id="inputFormNameContact"
                        onChange={this.onChangeNameContactUs}
                      />
                    </Grid.Row>
                    <Divider hidden />
                    <Grid.Row>
                      <Form.Input
                        placeholder="Votre Email"
                        type="email"
                        id="inputFormMailContact"
                        onChange={this.onChangeMailContactUs}
                      />
                    </Grid.Row>
                    <Divider hidden />
                    <Grid.Row>
                      <Form.TextArea
                        placeholder="Votre message !"
                        id="inputFormTextContact"
                        onChange={this.onChangeTextContactUs}
                      />
                    </Grid.Row>
                    <Divider hidden />
                    <p style={{ color: "white" }}>
                      <input type="checkbox" required name="terms" />{" "}
                      {t("terms_agreement")}{" "}
                      <Link style={{ color: "white" }} to="/termsandconditions">
                        {t("termsandconditions")}
                      </Link>
                      .{" "}
                    </p>
                    <Grid.Row>
                      <Button
                        type="submit"
                        id="inputFormButtonContact"
                        circular
                        fluid
                      >
                        <Header as="a" style={{ color: "white" }}>
                          {t("Segment7_button")}
                        </Header>
                      </Button>
                    </Grid.Row>
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Segment>

        <FooterComponent />
      </div>
    )
  }
}

export default translate("LandingComponent")(
  connect(mapStateToProps)(LandingComponent)
)



// WEBPACK FOOTER //
// ./src/components/Public/LandingPage/LandingComponent.js